import React, { useEffect, useState } from 'react'
import { MDBCol, MDBRow } from 'mdb-react-ui-kit'
import MDB4Switch from '../../../../../components/forms/MDB4Switch'
import UserProfileService from '../../../../../shared/services/UserProfile.service'
import UserService from '../../../../../shared/services/User.service'
import { toast } from 'react-toastify'

import './AccessManagement.component.scss'

const AccessManagement = () => {
  const [hasLeaderRequirements, setHasLeaderRequirements] = useState(
    parseInt(UserProfileService.get('has_leader_requirements'))
  )
  const [hasAgencyBuilderAccess, setHasAgencyBuilderAccess] = useState(
    parseInt(UserProfileService.get('has_agency_builder_access'))
  )

  const [canUpgradeSignature, setCanUpgradeSignature] = useState(
    parseInt(UserProfileService.get('can_upgrade_signature'))
  )

  const toggleAccess = async access_type => {
    const prevValue = parseInt(UserProfileService.get(access_type))
    const newValue = prevValue === 1 ? 0 : 1

    UserProfileService.set(access_type, newValue)

    if (access_type === 'has_leader_requirements') {
      setHasLeaderRequirements(newValue)
    } else if (access_type === 'has_agency_builder_access') {
      setHasAgencyBuilderAccess(newValue)
    } else if (access_type === 'can_upgrade_signature') {
      setCanUpgradeSignature(newValue)
    }

    try {
      await UserService.update(UserProfileService.getUserId(), {
        [access_type]: newValue,
      })
      toast.success(
        `${prevValue === 1 ? 'Disabled' : 'Enabled'} ${
          access_type === 'has_leader_requirements'
            ? 'leader requirements'
            : access_type === 'has_agency_builder_access'
            ? 'Agency Builder & Agent Enrollment access'
            : 'Prevent Signature Agent Upgrade'
        }.`,
        { position: toast.POSITION.TOP_RIGHT }
      )
    } catch (error) {
      toast.error(
        `Failed to ${prevValue === 1 ? 'disable' : 'enable'} ${
          access_type === 'has_leader_requirements'
            ? 'leader requirements'
            : access_type === 'has_agency_builder_access'
            ? 'Agency Builder & Agent Enrollment access'
            : 'Prevent Signature Agent Upgrade'
        }.`,
        { position: toast.POSITION.TOP_RIGHT }
      )
    }
  }

  const renderLeaderRequirementsSwitch = () => {
    if (UserProfileService.isA('premier-agent'))
      return (
        <div style={{ width: '120px' }}>
          <MDB4Switch
            labelLeft='No'
            labelRight='Yes'
            name={'has_leader_requirements'}
            checked={hasLeaderRequirements === 1}
            onChange={event => toggleAccess('has_leader_requirements')}
          />
        </div>
      )

    if (UserProfileService.isA(['division-leader', 'region-leader', 'district-leader']))
      return <div>This agent&apos;s leader-type requires completion of leader requirements.</div>

    return <div>Not applicable for this agent&apos;s usertype.</div>
  }

  const renderUpgradeSignatureSwitch = () => {
    if (UserProfileService.isA(['affiliate-agent', 'associate-agent'])) {
      return (
        <div style={{ width: '120px' }}>
          <MDB4Switch
            labelLeft='No'
            labelRight='Yes'
            name={'can_upgrade_signature'}
            checked={canUpgradeSignature === 1}
            onChange={event => toggleAccess('can_upgrade_signature')}
          />
        </div>
      )
    }
    return <div>Not applicable for this agent&apos;s usertype.</div>
  }

  const renderAgencyBuilderSwitch = () => {
    if (UserProfileService.isA('signature-agent-complete')) {
      return (
        <div style={{ width: '120px' }}>
          <MDB4Switch
            labelLeft='No'
            labelRight='Yes'
            name={'has_agency_builder_access'}
            checked={hasAgencyBuilderAccess === 1}
            onChange={event => toggleAccess('has_agency_builder_access')}
          />
        </div>
      )
    }
    return <div>Not applicable for this agent&apos;s usertype.</div>
  }

  return (
    <div id='AccessManagementComponent'>
      <MDBRow>
        {(UserProfileService.isA('premier-agent') || true) && (
          <>
            <MDBCol sm='6' md='8' lg='6'>
              <div className='access-toggle-label'>
                <div>Has Leader Requirements:</div>
              </div>
            </MDBCol>
            <MDBCol sm='6' md='4' lg='6' className='access-toggle'>
              {renderLeaderRequirementsSwitch()}
            </MDBCol>
          </>
        )}
      </MDBRow>

      <MDBRow className='mt-4'>
        {UserProfileService.isA('signature-agent-complete') && (
          <>
            <MDBCol sm='6' md='8' lg='6'>
              <div className='access-toggle-label'>
                <div>Permit Access to Agency Builder & Agent Enrollment:</div>
              </div>
            </MDBCol>
            <MDBCol sm='6' md='4' lg='6' className='access-toggle'>
              {renderAgencyBuilderSwitch()}
            </MDBCol>
          </>
        )}
      </MDBRow>
      <MDBRow className='mt-4'>
        {UserProfileService.isA(['affiliate-agent', 'associate-agent']) && (
          <>
            <MDBCol sm='6' md='8' lg='6'>
              <div className='access-toggle-label'>
                <div>Prevent Signature Agent Upgrade:</div>
              </div>
            </MDBCol>
            <MDBCol sm='6' md='4' lg='6' className='access-toggle'>
              {renderUpgradeSignatureSwitch()}
            </MDBCol>
          </>
        )}
      </MDBRow>
    </div>
  )
}

export default AccessManagement
